import React from 'react';
import { Box, Typography } from '@mui/material';

// Import logos
// Import logos
import windowsDefenderLogo from '../../assets/windows-defender.png';
import avastLogo from '../../assets/avast_clean.png';

const SecurityBadges: React.FC = () => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // McAfee SVG Logo construction
  const McAfeeLogo = () => (
    <svg width="140" height="50" viewBox="0 0 140 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 9.686L4.216 0.066V38.248L25 47.934L45.784 38.22V0.066L25 9.686ZM37.31 32.874L25.058 38.544L12.804 32.874V13.408L25.058 19.076L37.31 13.408V32.874Z" fill="#C01818" />
      <text x="55" y="32" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="700" fill="#424242">McAfee</text>
    </svg>
  );

  // Kaspersky SVG Logo construction (Text based approximation for clean edges on any bg)
  const KasperskyLogo = () => (
    <svg width="140" height="40" viewBox="0 0 140 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="0" y="28" fontFamily="Segoe UI, Roboto, Helvetica, Arial, sans-serif" fontSize="24" fontWeight="600" fill="#006D5C" letterSpacing="-0.5">kaspersky</text>
    </svg>
  );

  return (
    <Box
      sx={{
        py: { xs: 1, sm: 2 },
        bgcolor: '#FFFFFF',
        overflow: 'hidden',
      }}
    >
      {/* Heading */}
      <Typography
        variant="h6"
        component="h2"
        sx={{
          fontSize: { xs: '13px', sm: '14px' },
          fontWeight: 700,
          textTransform: 'uppercase',
          color: '#1A237E',
          letterSpacing: { xs: '1px', sm: '1.5px' },
          textAlign: 'center',
          mb: 3,
        }}
      >
        RECOGNIZED AS SAFE TO USE BY:
      </Typography>

      {/* Infinite Scrolling Strip */}
      <Box
        sx={{
          width: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 2, sm: 3 }, // Reduced gap from 4-6 to 2-3
            animation: 'scroll-logos 60s linear infinite',
            width: 'max-content',
            '&:hover': {
              animationPlayState: 'paused',
            },
          }}
        >
          {/* Repeat logos multiple times for seamless infinite scroll */}
          {[...Array(8)].map((_, repeatIndex) => (
            <React.Fragment key={repeatIndex}>
              {/* Microsoft Defender */}
              <Box sx={{ minWidth: { xs: '160px', sm: '200px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src={windowsDefenderLogo}
                  alt="Microsoft Defender"
                  style={{
                    height: '55px',
                    width: 'auto',
                    objectFit: 'contain',
                    mixBlendMode: 'multiply' // Blend white bg if present
                  }}
                  data-track="image"
                  data-name="security_microsoft_logo"
                />
              </Box>

              {/* McAfee - SVG */}
              <Box
                sx={{ minWidth: { xs: '140px', sm: '160px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                data-track="image"
                data-name="security_mcafee_logo"
              >
                <McAfeeLogo />
              </Box>

              {/* Avast - Image */}
              <Box sx={{ minWidth: { xs: '140px', sm: '160px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src={avastLogo}
                  alt="Avast"
                  style={{
                    height: '45px',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                  data-track="image"
                  data-name="security_avast_logo"
                />
              </Box>

              {/* Kaspersky - SVG */}
              <Box
                sx={{ minWidth: { xs: '140px', sm: '160px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                data-track="image"
                data-name="security_kaspersky_logo"
              >
                <KasperskyLogo />
              </Box>
            </React.Fragment>
          ))}
        </Box>
      </Box>

      {/* Keyframes for animation */}
      <style>
        {`
          @keyframes scroll-logos {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default SecurityBadges;
